import React, {Component} from 'react';
import leftPad from "left-pad";
import connect from "react-redux/es/connect/connect";
import Timer from "../../assets/img/icons/timer.svg";
import apiCall from "../apiCall";
import ClassLeaderTimerController from "./ClassLeaderTimerController";
import timerEnded from '../../assets/audio/timer-ended.wav';

class HeaderCountdown extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {
      toggleDropdown: false,
      timer: '00:00',
      classLeaderTime: 'Timer',
      deltaTimeMs: 0,
    };
    this.timerEndsAt = props.schoolClass.timerEndsAt || new Date().toISOString();
    this.timerPausedAt = props.schoolClass.timerPausedAt || null;
    this.toggleFlipCountDownDropdown = this.toggleFlipCountDownDropdown.bind(this);
    this.updateTimer = this.updateTimer.bind(this);
    this.timerEndedSoundRef = React.createRef();
  }

  componentWillMount = async () => {
    if (this.timerPausedAt === null) {
      this.interval = setInterval(this.updateTimer.bind(this, true), 1000);
    } else {
      this.updateTimer(false, true);
    }
    this.setState({
      deltaTimeMs: await this.getTimeDifferenceInSeconds(),
    })
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    if (this.state.timer === '00:01' && nextState.timer === '00:00' && this.timerEndedSoundRef.current) {
      // this.timerEndedSoundRef.current.play();
    }
  }

  getTimeDifferenceInSeconds = async () => {
    const res = await apiCall('/define/time');
    if(res) {
      return (new Date(res.time)).getTime() - (new Date()).getTime();
    }
    return 0;
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  updateTimer(run, updateOnce = false) {
    if (this.timerPausedAt && !updateOnce) return null;
    // Variable 'run' tells if the timer should be running, or should display the time remaining (because the timer is paused by the school leader).
    let diff;
    if (run && this.timerPausedAt === null) {
      const now = new Date(Date.now() + this.state.deltaTimeMs);
      let end = new Date(this.timerEndsAt);
      diff = (end.getTime() - now.getTime());
    } else {
      //Timer is paused get remaining time.
        const pausedAt = (new Date(this.timerPausedAt)).getTime();
        const endsAt = (new Date(this.timerEndsAt)).getTime();
        diff = endsAt - pausedAt;
    }
    if (diff > 0) {
      const min = Math.floor((diff/1000/60) << 0);
      const sec = Math.floor((diff/1000) % 60);
      this.setState({
        timer: `${leftPad(min, 2, 0)}:${leftPad(sec, 2, 0)}`,
      });
    }
  }

  componentWillReceiveProps({ schoolClass }) {
    if (this.timerEndsAt !== schoolClass.timerEndsAt) {
      this.timerEndsAt = schoolClass.timerEndsAt;
      if(this.timerEndsAt === null) {
        this.setState({
          timer: `00:00`,
        });
        this.updateTimer(false);
      } else {
        this.interval = setInterval(this.updateTimer.bind(this, true), 1000);
      }
    }
    if (this.timerPausedAt !== schoolClass.timerPausedAt) {
      this.timerPausedAt = schoolClass.timerPausedAt;
    }
  }

  toggleFlipCountDownDropdown() {
    const { toggleDropdown } = this.state;
    this.setState(prevState => ({
      toggleDropdown: !prevState.toggleDropdown
    }));

    if (!toggleDropdown) {
      document.body.classList.add('noScroll');
    } else {
      document.body.classList.remove('noScroll');
    }
  }

  render() {
    return (
      <div className={'timer-dropdown' + (this.state.toggleDropdown ? ' open' : '') + ' ' + this.props.role}>
        { this.props.user.role === 'classleader'
          ?
          <span className={'flipcountdown-container'}>
            <img alt="timer" src={Timer}/>
            <p className={'timertoggle'} onClick={this.toggleFlipCountDownDropdown}>{this.state.timer}</p>
            <span className="arrow-button" onClick={this.toggleFlipCountDownDropdown}></span>
            {this.props.schoolClass.id ? (
              <ClassLeaderTimerController
                schoolClassId={this.props.schoolClass.id}
                timerEndsAt={this.props.schoolClass.timerEndsAt}
                timerPausedAt={this.props.schoolClass.timerPausedAt}
                toggleFlipCountDownDropdown={this.toggleFlipCountDownDropdown}
              />
            ) : null}
          </span>

          :
          <span>
            <img alt="timer" src={Timer}/>
            <p>{this.state.timer}</p>
          </span>}
          <audio ref={this.timerEndedSoundRef} autoPlay={false}>
            <source src={timerEnded} type="audio/wav" />
          </audio>
      </div>
    )
  }
}
export default connect(({user, gameState, schoolClass, timer}) => ({user, gameState, schoolClass, timer}))(HeaderCountdown);



// WEBPACK FOOTER //
// ./src/components/elements/HeaderCountdown.js